<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-lg-6 col-md-8 mx-auto mt-5">
      <div class="card shadow-sm">
        <div class="card-body text-center p-5">
          <!-- Loading State -->
          <div *ngIf="loading" class="py-4">
            <div class="spinner-border text-success mb-3" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="text-muted">Please wait while we activate your account...</p>
          </div>

          <!-- Success State -->
          <div *ngIf="!loading && validated" class="py-3">
            <div class="mb-4">
              <i class="fa fa-check-circle text-success" style="font-size: 64px;"></i>
            </div>
            <h3 class="card-title mb-3 text-success">{{message}}</h3>
            <p class="text-muted mb-4">Your account is now ready to use.</p>
            <button (click)="navigateToLogin()" class="btn btn-success btn-lg px-5">
              <i class="fa fa-sign-in me-2"></i>
              Activation was successful now login
            </button>
          </div>

          <!-- Error State -->
          <div *ngIf="!loading && !validated" class="py-3">
            <div class="mb-4">
              <i class="fa fa-times-circle text-danger" style="font-size: 64px;"></i>
            </div>
            <h3 class="card-title mb-3 text-danger">{{message}}</h3>
            <p class="text-muted mb-4">You will be redirected to the homepage shortly.</p>
            <div class="spinner-border spinner-border-sm text-muted" role="status">
              <span class="visually-hidden">Redirecting...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
